/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxReducer } from '@reducers/types';
import { AnyAction } from '@reduxjs/toolkit';
import { UniversalTrackerPlain } from '../types/universalTracker';

type State = ReduxReducer<UniversalTrackerPlain[]> & { initiativeId: null | string }

const universalTrackers = (

  state: State = {
    data: [],
    initiativeId: null,
    loaded: false,
    errored: false,
    errorMessage: ''
  },
  action: AnyAction

): State => {

  switch (action.type) {

    case actionTypes.LOADING_UNIVERSALTRACKERS:
      return { ...state, initiativeId: action.initiativeId, data: [], loaded: false, errored: false, lastUpdated: Date.now() }
    case actionTypes.ERROR_UNIVERSALTRACKERS:
      return { ...state, data: [], loaded: false, errored: true, lastUpdated: Date.now(), errorMessage: action.errorMessage }
    case actionTypes.NO_DATA_UNIVERSALTRACKERS:
      return { ...state, initiativeId: action.initiativeId, data: [], loaded: false, errored: false, lastUpdated: Date.now() }
    case actionTypes.LOADED_UNIVERSALTRACKERS:
      return { ...state, initiativeId: action.initiativeId, data: action.data, loaded: true, errored: false, lastUpdated: Date.now() }
    default:
      return state;

  }

}

export default universalTrackers;
